import { render, staticRenderFns } from "./SkillHeaderIcon.vue?vue&type=template&id=90c47f54&scoped=true&"
import script from "./SkillHeaderIcon.vue?vue&type=script&lang=js&"
export * from "./SkillHeaderIcon.vue?vue&type=script&lang=js&"
import style0 from "./SkillHeaderIcon.vue?vue&type=style&index=0&id=90c47f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c47f54",
  null
  
)

export default component.exports